import React from "react";
import Chart from "react-apexcharts";
import { dashboardChartProps } from "../../core/dto/dashboard.dto";
import { PieBarChart } from "./PieBarChart";

const MissedCallPieChart: React.FC<dashboardChartProps> = ({ apiEndpoint, startDate, endDate, selectedLocation, selectedAgent, selectedCallType, onChartLoaded }) => {

  const chartData = PieBarChart({
    apiEndpoint, startDate, endDate, labelKey: "label", valueKey: "missed_call_count", chartType: "pie",
    labelFormatter: (l) => (typeof l === "string" && l.length > 0) ? l.charAt(0).toUpperCase() + l.slice(1) : "",
    chartName: "missed",
    payloadExtra: { agent_id: selectedAgent, location_id: selectedLocation, call_type: selectedCallType },
    onChartLoaded
  });

  return (
    <div className="overflow-hidden">
      <div className="row mb-3 chart-header" style={{ borderBottom: "2px solid #ddd", paddingBottom: "10px" }} >
        <div className="col-12"><h5 className="text-center">Missed Calls</h5></div>
      </div>
      <div className="col-12">
        {chartData && chartData.count > 0 ? (
          <Chart
            options={chartData.labels}
            series={chartData.series}
            type="pie"
            height={380}
          />
        ) : (
          <div className="text-center py-4">No Records Found</div>
        )}
      </div>
    </div>
  );
};

export default MissedCallPieChart;
